export default __webpack_public_path__ + "static/media/invoice.0ade63f9.png";